export default __webpack_public_path__ + "static/integrated_in_your_toolchain-8d54a76f28b94c3f7767849342efa204.svg";